<template>
    <layout>
        <!-- Controls -->
    	<div class="row">
    		<div class="col-xs-12">
    			<div class="block block-rounded">
    				<div class="block-content block-content-full">
    					<div class="row">
    						<div class="visible-xs push-10"></div>
    						<div class="col-sm-2 text-right">
    							<button class="btn btn-primary btn-block" data-toggle="modal" data-target="#modal-create-inspector">
                                    <i class="fa fa-plus"></i> New Forester
    							</button>
    						</div>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    	<!-- END controls -->

        <!-- Inspectors table -->
    	<div :class="[(working) ? 'block-opt-refresh' : '', 'block', 'block-rounded']">
    		<div class="block-content" style="min-height: 300px;">
    			<div class="table-responsive">
    				<table class="table table-hover table-vcenter table-clickable-rows">
						<thead>
							<tr>
								<th></th>
								<th>Name</th>
								<th>Email</th>
								<th>Phone</th>
								<th>Region</th>
								<!-- <th></th> -->
							</tr>
						</thead>
    					<tbody>
    						<tr v-for="inspector in inspectors" v-on:click="onRowClick($event.target, inspector)">
    							<td>
    								<i class="icon-user text-muted"></i>
    							</td>
    							<td class="font-w600">
                                    <router-link v-bind:to="'foresters/' + inspector.id">{{ inspector.user.contact.first_name }} {{ inspector.user.contact.last_name }}</router-link>
                                </td>
    							<td>{{ inspector.user.email }}</td>
    							<td>{{ inspector.user.contact.phone }}</td>
    							<td>{{ inspector.user.contact.region.name }}</td>
    							<td class="text-right">
    								<button v-if=inspector.enabled class="btn btn-xs btn-danger" type="button" @click="onInspectorDisable(inspector)">
    									Disable
    								</button>
    								<button v-else class="btn btn-xs btn-success" type="button" @click="onInspectorEnable(inspector)">
    									Enable
    								</button>
    							</td>
    						</tr>
    					</tbody>
    				</table>
    			</div>
    		</div>
    	</div>
    	<!-- END Foresters table -->

        <inspector-create-modal v-on:created="getInspectors"></inspector-create-modal>
    </layout>
</template>

<script>
    export default {
        name: 'inspectors',
        data () {
            return {
                inspectors: null,
				search: '',
				working: true
            };
        },
        components: {
            layout: require('../layouts/default.vue'),
            inspectorCreateModal: require('../elements/inspector-create-modal.vue')
        },
        methods: {
            getInspectors () {
                var self = this;
                var searchString = '';
                if (self.search) {
                    var searchable = {'id': '=', 'first_name': '~', 'last_name': '~', 'email': '~'};
                    _.each(searchable, function (symbol, field) {
                        searchString += (searchString === '' ? '?q=' : '|^') + field + symbol + (symbol === '~' ? '*' : '') + self.search + (symbol === '~' ? '*' : '');
                    });
				}

				this.working = true;

                self.axios.get('inspectors?include=contact').then((response) => {
					self.inspectors = response.data.data;
					self.working = false;
                });
            },
            onRowClick(target, inspector) {
                if(target.type != "button" && (!target.parentNode || target.parentNode.type != "button")) { // hack for 'times' on the button
                    this.$router.push({ path: '/foresters/'+inspector.id })
                }
            },
            onInspectorDisable(inspector) {
                this.$swal({
                    title: `Disable ${inspector.user.contact.first_name} ${inspector.user.contact.last_name}?`,
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Disable',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        return this.axios.post(`inspectors/${inspector.id}/disable`).then((result) => {
                            this.getInspectors();
                            this.$swal(
                                'Success!',
                                'The inspector privileges have been disabled.',
                                'success'
                            )
                        });
                    }
                });
            },
            onInspectorEnable(inspector) {
                this.$swal({
                    title: `Enable ${inspector.user.contact.first_name} ${inspector.user.contact.last_name}?`,
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Enable',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        return this.axios.post(`inspectors/${inspector.id}/enable`).then((result) => {
                            this.getInspectors();
                            this.$swal(
                                'Success!',
                                'The inspector privileges have been enabled.',
                                'success'
                            )
                        });
                    }
                });
            }
        },
        mounted () {
            // Get all landowners
            this.getInspectors();
        }
    };
</script>



// WEBPACK FOOTER //
// foresters.vue?a4d9feec